<div class="bannerWrap">
    <div class="maxContainerWidth flex md:flex-row flex-col items-center justify-between">
        <div class="contentWrap">
            <h4 class="text-gradient "> PostEx paid </h4>
            <h2 class="capitalize"> Payment Gateway <br class="hidden">for all businesses </h2>
            <p>The most reliable and secure payment gateway tailored to support your business & accept online payments from your customers.</p>

            <div class="getInTouch">
                <h4>Get in Touch </h4>
                <div class="btnWrap">
                    <button>
                        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                            <path d="M1.93823 11.1975H21.2963" stroke="#11151A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M11.6172 2.12347L21.2962 11.5L11.6172 20.8766" stroke="#11151A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <div class="imageWrap">
            <img src="assets/svgs/payment_gateway_section.svg" alt="">
        </div>
    </div>
</div>